<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img
          :src="require('@/assets/images/umg/UmgLogo.png')"
          alt="UMG Logo"
          height="40"
          class="mr-2"
        />
        <h2 class="brand-text text-primary ml-1">
          UMG
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
            height="400"
            width="400"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
            ¡Bienvenido a UMG! 🎓
          </b-card-title>
          <b-card-text class="mb-2">
            Inicia sesión en el Sistema de Asignación de Cursos
          </b-card-text>

          <b-alert
            variant="primary"
            show
          >
            <div class="alert-body font-small-2">
              <p>
                <small class="mr-50"><span class="font-weight-bold">Administrador:</span> admin@miumg.edu.gt | Admin123</small>
              </p>
            </div>
            <feather-icon
              v-b-tooltip.hover.left="'Credenciales de demostración para diferentes roles'"
              icon="HelpCircleIcon"
              size="18"
              class="position-absolute"
              style="top: 10; right: 10;"
            />
          </b-alert>

          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                label="Usuario"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Usuario"
                  rules="required"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="admin@miumg.edu.gt"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Contraseña</label>
                  <b-link :to="{name:'auth-forgot-password'}">
                    <small>¿Olvidaste tu contraseña?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Contraseña"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Admin123"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Recordarme
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Iniciar Sesión
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <span>¿Nuevo en la plataforma? </span>
            <a href="mailto:soporte@miumg.edu.gt">
              <span>&nbsp;Contacta al administrador</span>
            </a>
          </b-card-text>

          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text">
              o
            </div>
          </div>

          <!-- social buttons -->
          <div class="auth-footer-btn d-flex justify-content-center">
            <b-button
              variant="facebook"
              href="javascript:void(0)"
            >
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button
              variant="twitter"
              href="javascript:void(0)"
            >
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button
              variant="google"
              href="javascript:void(0)"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button
              variant="github"
              href="javascript:void(0)"
            >
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BAlert, VBTooltip,
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import authService from '@/services/authService'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: 'Admin123',
      userEmail: 'admin@miumg.edu.gt',
      sideImg: require('@/assets/images/umg/new_logo.png'),

      // validation rules
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      // Usar siempre la misma imagen del laboratorio
      return this.sideImg
    },
  },
  methods: {
    async login() {
      try {
        // Validar formulario antes de enviar
        const isValid = await this.$refs.loginForm.validate()
        if (!isValid) return

        // Mostrar loading
        this.$refs.loginForm.setErrors({})
        
        // Preparar datos para la API
        const loginData = {
          username: this.userEmail,
          password: this.password
        }

        // Llamar al servicio de autenticación
        const response = await authService.login(loginData)
        
        if (response && response.token && response.user) {
          // authService ya guardó los datos en localStorage con abilities
          // Solo necesitamos actualizar CASL y redirigir
          const userData = response.user
          
          console.log('🔐 Login exitoso:', {
            usuario: userData.username,
            rol: userData.role,
            abilities: userData.ability
          })
          
          // Actualizar abilities basado en roles
          this.$ability.update(userData.ability)

          // Redirigir según el rol
          this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Bienvenido ${userData.fullName || userData.username}`,
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: `Has iniciado sesión como ${userData.role}. ¡Ahora puedes empezar a explorar!`,
                },
              })
            })
        } else {
          throw new Error('Respuesta inválida del servidor')
        }
      } catch (error) {
        console.error('Error en login:', error)
        
        let errorMessage = 'Error al iniciar sesión'
        
        if (error.response?.status === 401) {
          errorMessage = 'Credenciales inválidas'
        } else if (error.response?.status === 400) {
          errorMessage = 'Datos de entrada inválidos'
        } else if (error.response?.data?.error) {
          errorMessage = error.response.data.error
        } else if (error.message) {
          errorMessage = error.message
        }

        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Error de autenticación',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: errorMessage,
          },
        })
      }
    },

    mapUserData(backendUser) {
      // Mapear datos del backend al formato del frontend
      const primaryRole = backendUser.roles && backendUser.roles.length > 0 
        ? backendUser.roles[0].nombre.toLowerCase() 
        : 'usuario'

      // Obtener abilities usando el método centralizado de authService
      const ability = authService.getUserAbilities(primaryRole)

      return {
        id: backendUser.usuarioId,
        fullName: backendUser.username,
        username: backendUser.username,
        avatar: require('@/assets/images/avatars/13-small.png'),
        email: backendUser.username,
        role: primaryRole,
        ability: ability,
        backendData: backendUser // Mantener datos originales del backend
      }
    },

    /* login() {
      const loginData = {
        Usuario: this.userEmail,
        Password: this.password,
      }
      this.$http
        .post('/login/', loginData)
        .then(response => {
          console.log(response)
          if (response.data) {
            const userResponse = response.data
            let userData = {}
            const Roles = response.data.Roles.length > 0 ? response.data.Roles[0] : 'client'
            console.log(Roles)
            if (Roles === 'ADMIN') {
              userData = {
                id: userResponse.UsuarioId,
                fullName: userResponse.Usuario,
                username: userResponse.Usuario,
                avatar: '/img/13-small.d796bffd.png',
                email: 'admin@demo.com',
                role: 'admin',
                ability: [
                  { action: 'manage', subject: 'all' },
                ],
                extras: { eCommerceCartItemsCount: 5 },
              }
            } else {
              userData = {
                id: userResponse.UsuarioId,
                fullName: userResponse.Usuario,
                username: userResponse.Usuario,
                password: 'client',
                // eslint-disable-next-line global-require
                avatar: require('@/assets/images/avatars/1-small.png'),
                email: 'client@demo.com',
                role: 'client',
                ability: [
                  {
                    action: 'manage',
                    subject: 'all',
                  },
                  {
                    action: 'read',
                    subject: 'Auth',
                  },
                ],
                extras: {
                  eCommerceCartItemsCount: 5,
                },
              }
            }

            localStorage.setItem('userData', JSON.stringify(userData))
            this.$ability.update(userData.ability)
            this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
              .then(() => {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Welcome ${userData.fullName || userData.username}`,
                    icon: 'CoffeeIcon',
                    variant: 'success',
                    text: `You have successfully logged in as ${Roles}. Now you can start to explore!`,
                  },
                })
              })
          } else {
            throw new Error('Credenciales invalidas')
          }
        })
        .catch(error => {
          this.mostrarError(`Error al iniciar sesion: ${error.message}`)
        })
    }, */
    loginOld() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          useJwt.login({
            email: this.userEmail,
            password: this.password,
          })
            .then(response => {
              const { userData } = response.data
              useJwt.setToken(response.data.accessToken)
              useJwt.setRefreshToken(response.data.refreshToken)
              localStorage.setItem('userData', JSON.stringify(userData))
              this.$ability.update(userData.ability)

              // ? This is just for demo purpose as well.
              // ? Because we are showing eCommerce app's cart items count in navbar
              this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', userData.extras.eCommerceCartItemsCount)

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
                .then(() => {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: `Welcome ${userData.fullName || userData.username}`,
                      icon: 'CoffeeIcon',
                      variant: 'success',
                      text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
                    },
                  })
                })
            })
            .catch(error => {
              this.$refs.loginForm.setErrors(error.response.data.error)
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
